import { Box } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

export const Divider = () => (
  <Box
    style={{
      height: 2,
      backgroundColor: colors.neutral['100'],
      marginTop: 20,
      marginBottom: 20,
    }}
  />
);
